<!--begin section-coverage -->
<section class="section-coverage" id="country-coverage-section">
    <div class="coverage-content">
        <div class="row country-coverage-img">
            <div class="col-12 ctry-cv-pd">
                <h3 class="coverage-heading" style="margin-top: 20px;">Country Coverage for International Payments
                </h3>
                <!-- <ul class="nav nav-tabs" style="padding-left: 0rem;">
                    <li style="padding-left: 0rem;" class="nav-tab" (click)="countryListPaymentType = 'local_payment'; selectTab('Asia');"
                        [class.active]="countryListPaymentType === 'local_payment'">
                        Local Payment
                    </li>
                    <li style="padding-left: 0rem;" class="nav-tab" (click)="countryListPaymentType = 'shift_payment'; selectTab('Africa')"
                        [class.active]="countryListPaymentType === 'shift_payment'">
                        Swift Payment
                    </li>
                </ul> -->
                <p class="mb-0 pb-2 cntry-cvg" *ngIf="countryListPaymentType === 'local_payment'">
                    Make Local currency payments to over 50 countries worldwide.
                </p>
                <p class="mb-0 pb-2 cntry-cvg" *ngIf="countryListPaymentType === 'shift_payment'">
                    Make USD, EURO, GBP, JPY, NZD, SGD, HKD, CNY, AUD payments to over 180 countries worldwide.
                </p>

            </div>
            <div class="col-12">
                <div class="row text-start">
                    <div  class="col-12 payment-type">
                        <nz-radio-group class="payment-type-radio" [(ngModel)]="countryListPaymentType"
                            nzButtonStyle="solid" nzSize="large" (ngModelChange)="onPaymentTypeSelect()">
                            <label nz-radio-button nzValue="local_payment">LOCAL PAYMENT</label>
                            <label nz-radio-button nzValue="shift_payment">SWIFT PAYMENT</label>
                        </nz-radio-group>
                    </div>
                </div>
                <ul class="nav nav-tabs cntry-nav-tabs" *ngIf="countryListPaymentType === 'local_payment'">
                    <li class="nav-tab" (click)="selectTab('Asia')" [class.active]="activeTab === 'Asia'">
                        Asia
                    </li>
                    <li class="nav-tab" (click)="selectTab('Africa')" [class.active]="activeTab === 'Africa'">
                        Africa
                    </li>
                    <li class="nav-tab" (click)="selectTab('Europe')" [class.active]="activeTab === 'Europe'">
                        Europe
                    </li>
                    <li class="nav-tab" (click)="selectTab('North America')"
                        [class.active]="activeTab === 'North America'">
                        North America
                    </li>
                    <li class="nav-tab" (click)="selectTab('Oceania')" [class.active]="activeTab === 'Oceania'">
                        Oceania
                    </li>
                </ul>

                <ul class="nav nav-tabs cntry-nav-tabs" *ngIf="countryListPaymentType === 'shift_payment'">

                    <li class="nav-tab" (click)="selectTab('Asia')" [class.active]="activeTab === 'Asia'">
                        Asia
                    </li>
                    <li class="nav-tab" (click)="selectTab('Africa')" [class.active]="activeTab === 'Africa'">
                        Africa
                    </li>
                    <li class="nav-tab" (click)="selectTab('Europe')" [class.active]="activeTab === 'Europe'">
                        Europe
                    </li>
                    <li class="nav-tab" (click)="selectTab('North America')"
                        [class.active]="activeTab === 'North America'">
                        North America
                    </li>
                    <li class="nav-tab" (click)="selectTab('South America')"
                        [class.active]="activeTab === 'South America'">
                        South America
                    </li>
                    <li class="nav-tab" (click)="selectTab('Oceania')" [class.active]="activeTab === 'Oceania'">
                        Oceania
                    </li>
                </ul>

            </div>
            <div class="tabs-body p-5">


                <ng-container *ngIf="countryListPaymentType === 'local_payment'">
                    <div class="county-box" *ngFor="let country of filteredCountryFlags[countryListPaymentType]">
                        <div class="img-box">
                            <img [src]="countryFlagBaseURL + country.flag" alt="country.name" class="lazyload">
                        </div>
                        <span class="ctry-txt font_inter" style="font-size: 15px !important;">{{country.name}}</span>
                    </div>
                </ng-container>

                <ng-container *ngIf="countryListPaymentType === 'shift_payment'">
                    <div class="county-box"
                        *ngFor="let country of filteredCountryFlags[countryListPaymentType]; index as i">
                        <div class="img-box">
                            <img [src]="countryFlagBaseURL + country.flag" alt="country.name" class="lazyload">
                        </div>
                        <span class="ctry-txt font_inter" style="font-size: 15px !important;">{{country.name }}</span>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- <img style="width: 100%;padding: 5rem;" src="./assets/images/CountryCoverage_desktop.webp"
        alt="International Payments - SingX" class="desktop d-none d-sm-none d-md-block">
    <img style="width: 98vw;" src="./assets/images/CountryCoverage_mobile.webp" alt="International Payments - SingX"
        class="p-3 mobile d-block d-sm-block d-md-none"> -->
</section>
<!--end section-coverage-->